module.exports = "<p class=\"informationText\">\n {{informationText}}\n</p>\n"